export default "__VITE_ASSET__lXnh89cS__"